import { collection, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from './firebase';
import type { PlatformAnnouncement } from './systemTypes';
import { safeParseDate } from './utils';

const ACTIVE_LIMIT = 5;

/** Active platform announcements for authenticated lawyer UI. */
export async function fetchActiveAnnouncements(): Promise<PlatformAnnouncement[]> {
  try {
    const snap = await getDocs(
      query(
        collection(db, 'platform_announcements'),
        where('active', '==', true),
        limit(ACTIVE_LIMIT),
      ),
    );
    return snap.docs
      .map((d) => ({ id: d.id, ...d.data() }) as PlatformAnnouncement)
      .sort(
        (a, b) =>
          safeParseDate(b.createdAt).getTime() - safeParseDate(a.createdAt).getTime(),
      )
      .slice(0, ACTIVE_LIMIT);
  } catch (error) {
    console.warn('[announcements] fetchActiveAnnouncements', error);
    return [];
  }
}

export function announcementDismissKey(uid: string, announcementId: string): string {
  return `lexgat_ann_dismissed_${uid}_${announcementId}`;
}
